import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import ScreeningService from '../../common/ScreeningService'

export const getSavedCriterias = createAsyncThunk(
  'tool/screening/getSavedCriterias',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.getSavedCriterias(params)
      if (response.success) return response
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getSavedCriteria = createAsyncThunk(
  'tool/screening/getSavedCriteria',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.getSavedCriteria(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const deleteSavedCriteria = createAsyncThunk(
  'tool/screening/deleteSavedCriteria',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await ScreeningService.deleteSavedCriteria(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
